import { http } from "@/apis";
import type {
  GenerateLicenseRequest,
  VerifyLicenseRequest,
  VerifyLicenseResponse,
} from "@/features/licenses/schemas/license";

type ApiSuccess<T> = { success: true; message: string; data: T };

export async function generateLicense(
  data: GenerateLicenseRequest
): Promise<{ success: boolean; message: string }> {
  const response = await http.post<ApiSuccess<void>>("/api/v1/license/generate", data);
  return {
    success: response.success,
    message: response.message,
  };
}

export async function verifyLicense(
  data: VerifyLicenseRequest
): Promise<{ success: boolean; message: string; data: VerifyLicenseResponse }> {
  const response = await http.post<ApiSuccess<VerifyLicenseResponse>>(
    "/api/v1/license/verify",
    data
  );
  return response;
}

/** Aprueba solicitud: firma RSA + crea licenses + marca request approved. */
export async function approveLicenseRequest(
  requestId: string
): Promise<{ success: boolean; message: string; data?: unknown }> {
  const response = await http.post<ApiSuccess<unknown>>(
    `/api/v1/license/requests/${encodeURIComponent(requestId)}/approve`,
    {}
  );
  return {
    success: response.success,
    message: response.message,
    data: response.data,
  };
}

/** Rechaza solicitud (no genera firma). */
export async function rejectLicenseRequest(
  requestId: string,
  reason?: string
): Promise<{ success: boolean; message: string; data?: unknown }> {
  const response = await http.post<ApiSuccess<unknown>>(
    `/api/v1/license/requests/${encodeURIComponent(requestId)}/reject`,
    reason?.trim() ? { reason: reason.trim() } : {}
  );
  return {
    success: response.success,
    message: response.message,
    data: response.data,
  };
}
